import * as React from 'react'
import useSWR from 'swr'
import axios from 'axios'
import { useLocale } from 'hooks'
import { withTranslations } from 'helpers'
import * as S from './PopularNow.styles'

interface PopularNowItem {
  id: number
  anchor_text: string
  url: string
  display_order: number
}

interface PopularNowResponse {
  homepage_popular_now_items: PopularNowItem[]
}

const PopularNow = () => {
  const { localiseUrl } = useLocale()
  const { data } = useSWR(
    '/api/v1/homepage_popular_now_items',
    (url) =>
      axios.get(url).then((response) => response.data as PopularNowResponse),
    { revalidateOnFocus: false }
  )

  const items = data?.homepage_popular_now_items || []

  if (!items.length) return null

  const row1Items = items.filter((_, i) => i % 2 === 0)
  const row2Items = items.filter((_, i) => i % 2 !== 0)

  const renderRow = (
    rowItems: PopularNowItem[],
    direction: 'left' | 'right'
  ) => (
    <S.MarqueeRow>
      <S.MarqueeTrack direction={direction}>
        {rowItems.map((item) => (
          <S.PopularNowLink
            key={item.id}
            href={localiseUrl(`${window.location.origin}${item.url}`)}
          >
            {item.anchor_text}
          </S.PopularNowLink>
        ))}
        <S.DuplicateSet aria-hidden="true">
          {rowItems.map((item) => (
            <S.PopularNowLink
              key={`dup-${item.id}`}
              href={localiseUrl(`${window.location.origin}${item.url}`)}
              tabIndex={-1}
            >
              {item.anchor_text}
            </S.PopularNowLink>
          ))}
        </S.DuplicateSet>
      </S.MarqueeTrack>
    </S.MarqueeRow>
  )

  return (
    <S.PopularNowWrapper>
      <S.SectionHeader>
        <S.SectionTitle>Popular Now</S.SectionTitle>
      </S.SectionHeader>
      <S.MarqueeArea>
        {renderRow(row1Items, 'left')}
        {renderRow(row2Items, 'right')}
      </S.MarqueeArea>
    </S.PopularNowWrapper>
  )
}

export default withTranslations(PopularNow)
